var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const Svg3Svg = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 140,
  height: 140,
  viewBox: "0 0 140 140",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 70,
  cy: 70,
  r: 70,
  fill: "#FFFDD0"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M91.4015 58.277C95.8963 58.277 99.54 54.6332 99.54 50.1385C99.54 45.6437 95.8963 42 91.4015 42C86.9068 42 83.2631 45.6437 83.2631 50.1385C83.2631 54.6332 86.9068 58.277 91.4015 58.277Z",
  fill: "#FF7FFB"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M96.3652 65.5208H85.4922V76.3938H96.3652V65.5208Z",
  fill: "white"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M96.3652 86.2568H85.4922V97.1299H96.3652V86.2568Z",
  fill: "white"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M74.6191 65.5208H63.7461V76.3938H74.6191V65.5208Z",
  fill: "white"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M74.6191 44.7041H63.7461V55.5771H74.6191V44.7041Z",
  fill: "white"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M74.6191 86.2568H63.7461V97.1299H74.6191V86.2568Z",
  fill: "white"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M52.873 65.5208H42V76.3938H52.873V65.5208Z",
  fill: "white"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M52.873 44.7041H42V55.5771H52.873V44.7041Z",
  fill: "white"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M52.873 86.2568H42V97.1299H52.873V86.2568Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(Svg3Svg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/3_svg.fbcc4e66e813d778581bcf7725a166ca.svg";